"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OutboundFormSubmissionTracking = /** @class */ (function () {
    /**
     * Setup tracking of outbound form form submissions
     */
    function OutboundFormSubmissionTracking(analytics) {
        this.analytics = analytics;
        var onFormSubmit = function (ev) {
            var target = ev.target || ev.srcElement;
            if (!(target instanceof Element) || target.tagName === undefined || target.tagName.toUpperCase() !== "FORM") {
                return;
            }
            var element = target; // Do not use HTMLFormEelement to get 'action' property because IE doe snot support that.
            var action = element.getAttribute("action");
            // Ignore form submission that are not to other domains
            if (action === null || action === undefined || action.indexOf("http") === -1) {
                return;
            }
            // Check if hostname is in the list of "local" hostnames
            var hostnames = analytics.getHostnames();
            if (hostnames !== undefined) {
                for (var i = 0; i < hostnames.length; i++) {
                    if (action.indexOf("//" + hostnames[i]) !== -1) {
                        return;
                    }
                }
            }
            // Track event
            analytics.trackEvent("Outbound Form Submissions", "Submit", action);
        };
        document.documentElement.addEventListener("submit", onFormSubmit, false);
    }
    return OutboundFormSubmissionTracking;
}());
exports.default = OutboundFormSubmissionTracking;
